import React, { createContext, useContext } from 'react';

import { TestType } from '@qality/common-model';

type TestTypePopupSelectContextValue = {
  selectedTestType: TestType;
  setSelectedTestType: (testType: TestType) => void;
};

export const initialContextValue: TestTypePopupSelectContextValue = {
  selectedTestType: null,
  setSelectedTestType: () => undefined,
};

export const TestTypePopupSelectContext =
  createContext<TestTypePopupSelectContextValue>(initialContextValue);

export const useTestTypePopupSelectContext =
  (): TestTypePopupSelectContextValue => {
    return useContext(TestTypePopupSelectContext);
  };

type Props = {
  selectedTestType: TestType;
  setSelectedTestType: (testType: TestType) => void;
  children: React.ReactNode;
};

export default function TestTypePopupSelectProvider({
  children,
  selectedTestType,
  setSelectedTestType,
}: Props): JSX.Element {
  return (
    <TestTypePopupSelectContext.Provider
      value={{
        selectedTestType,
        setSelectedTestType,
      }}
    >
      {children}
    </TestTypePopupSelectContext.Provider>
  );
}
